/**
 * Created by idea on 03/07/2017.
 */
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AdminNavComponent } from './admin-nav.component';

@NgModule({
  declarations: [AdminNavComponent],
  imports: [BrowserModule, RouterModule],
  exports: [AdminNavComponent],
})
export class NavigationModule {}



// WEBPACK FOOTER //
// ./src/app/layout/navigation/navigation.module.ts